export default {
  documentTitle:
    'Billetera de hardware - Tu aliado de llaves para garantizar los activos cripto | KeyPal',
  product: 'Producto',
  learn: 'Aprender',
  support: 'Soporte',
  others: 'Otros',
  language: 'Idioma',
  forBusiness: 'Para empresas',
  apps: 'Aplicaciones',
  KeyPal: 'KeyPal',
  KeyPalPlus: 'KeyPal Plus',
  secretBox: 'Secret Box',
  KeyPalCard: 'KeyPal Card', 
  learnMore: 'Saber más', 
  goShoppingCart: 'Ir a la tienda', 
  contactUs: 'Contáctenos:', 
  tutorials: 'Tutoriales', 
  mobileWallet: 'Billetera móvil', 
  extensionWallet: 'Billetera de extensión', 
  cases: 'Estudios de casos:', 
  cooperationSolution: 'Soluciones de asociación', 
  information: 'Información', 
  security: 'Seguridad', 
  darkMode: 'Modo oscuro',
  KeyPal_2_firmware: 'Firmware de KeyPal 2', 
  KeyPal_Plus_firmware: 'Firmware de KeyPal Plus',
  more: 'y mucho más...',
  comingSoon: 'Próximamente',
}
